import createReactContext from 'create-react-context';

var gatherPath = function gatherPath(itemId) {
  return [itemId];
};

var DrawerItemContext = createReactContext({ gatherPath: gatherPath });

export default DrawerItemContext;
//# sourceMappingURL=DrawerItemContext.js.map